import WelcomeGuideLayout from './WelcomeGuideLayout'

export default WelcomeGuideLayout
